import React from 'react'
import {FallbackProps} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {Alert, Box, Typography} from '@mui/material'
import {PGButton} from '@progynyglobal/pg-ui-library'

export function ErrorBoundaryFallback({
  error,
  resetErrorBoundary,
}: FallbackProps) {
  const {t} = useTranslation()

  return (
    <Box role={'alert'}>
      <Typography variant={'body2'}>
        {t('error_boundary_something_went_wrong')}
      </Typography>
      <PGButton
        aria-label={t('error_boundary_retry')}
        onClick={() => resetErrorBoundary()}
        label={t('error_boundary_retry')}
      />
      <Alert severity={'warning'}>{error.message}</Alert>
    </Box>
  )
}
